import AboutMe from "../../components/About Me/AboutMe"
import Projects from "../../components/Projects/Projects"
import Skills from "../../components/Skills/Skills"

const Home = (props) => {
  return (
    <div>
      <AboutMe />
      <Skills />
      <Projects />

    </div>
  )
}

export default Home